export default __webpack_public_path__ + "static/park-pedregal-amenidades-03-kids-club-eb221c171eb6745f59cc441a38dd7124.jpg";